import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_c83bb9d1-4481-4216-be0b-e2d2e530a3a4/artifacts/j5gcpl1b_Peaceful%20harmony%20in%20a%20logo%20design.png";

const NAV_ITEMS = [
  { label: "Products", href: "/#apps" },
  { label: "About", href: "/#about" },
  { label: "Founder", href: "/founder", isRoute: true },
  { label: "Privacy", href: "/privacy", isRoute: true },
  { label: "Contact", href: "/#contact" },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  const renderNavLink = (item) => {
    if (item.isRoute) {
      return (
        <Link
          key={item.label}
          to={item.href}
          data-testid={`nav-${item.label.toLowerCase()}`}
          className="text-sm font-medium text-slate-300 transition-all hover:text-white relative after:absolute after:bottom-[-6px] after:left-0 after:h-[2px] after:w-0 after:bg-blue-400 after:transition-all hover:after:w-full"
        >
          {item.label}
        </Link>
      );
    }
    // For anchor links: if on home page use hash, else navigate to home + hash
    const href = isHome ? item.href.replace("/", "") : item.href;
    return (
      <a
        key={item.label}
        href={href}
        data-testid={`nav-${item.label.toLowerCase()}`}
        className="text-sm font-medium text-slate-300 transition-all hover:text-white relative after:absolute after:bottom-[-6px] after:left-0 after:h-[2px] after:w-0 after:bg-blue-400 after:transition-all hover:after:w-full"
      >
        {item.label}
      </a>
    );
  };

  const renderMobileNavLink = (item) => {
    if (item.isRoute) {
      return (
        <Link
          key={item.label}
          to={item.href}
          onClick={() => setMobileOpen(false)}
          className="text-base font-medium text-slate-300 hover:text-white transition-colors py-3"
        >
          {item.label}
        </Link>
      );
    }
    const href = isHome ? item.href.replace("/", "") : item.href;
    return (
      <a
        key={item.label}
        href={href}
        onClick={() => setMobileOpen(false)}
        className="text-base font-medium text-slate-300 hover:text-white transition-colors py-3"
      >
        {item.label}
      </a>
    );
  };

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 border-b border-slate-800 bg-slate-950/90 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-8 py-4">
        <Link to="/" data-testid="header-logo" className="group flex items-center gap-3.5">
          <img
            src={LOGO_URL}
            alt="Perfect Peace Enterprise"
            className="h-12 w-auto object-contain transition-transform group-hover:scale-105"
          />
          <div>
            <div className="text-lg font-bold tracking-tight transition-colors group-hover:text-blue-400">
              Perfect Peace Enterprise
            </div>
            <div className="text-[10px] text-slate-500 tracking-wide uppercase font-semibold">
              Digital Products • Real Impact
            </div>
          </div>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden gap-8 md:flex" data-testid="desktop-nav">
          {NAV_ITEMS.map(renderNavLink)}
        </nav>

        {/* Mobile toggle */}
        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-slate-300 hover:text-white transition-colors p-2"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile nav */}
      {mobileOpen && (
        <nav
          data-testid="mobile-nav"
          className="md:hidden border-t border-slate-800 bg-slate-950/95 backdrop-blur-xl animate-fade-in"
        >
          <div className="flex flex-col px-8 py-6 gap-2">
            {NAV_ITEMS.map(renderMobileNavLink)}
          </div>
        </nav>
      )}
    </header>
  );
}
